// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plugNetIncomeMessage1{
position: relative;
bottom: 18px;
margin-left: 30px;
font-size: 12px !important;
}

.text-position-pnp{
    position: relative;
    top:-19px;
}

.text-position{
    position: relative;
    top: 1px;
}

:host ::ng-deep .p-datatable > .p-datatable-wrapper {
    overflow: unset; 
}


.scroll {
    overflow: auto;
    max-height: 250px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/performdatacheck/performdatacheck.component.css"],"names":[],"mappings":"AAAA;AACA,kBAAkB;AAClB,YAAY;AACZ,iBAAiB;AACjB,0BAA0B;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".plugNetIncomeMessage1{\r\nposition: relative;\r\nbottom: 18px;\r\nmargin-left: 30px;\r\nfont-size: 12px !important;\r\n}\r\n\r\n.text-position-pnp{\r\n    position: relative;\r\n    top:-19px;\r\n}\r\n\r\n.text-position{\r\n    position: relative;\r\n    top: 1px;\r\n}\r\n\r\n:host ::ng-deep .p-datatable > .p-datatable-wrapper {\r\n    overflow: unset; \r\n}\r\n\r\n\r\n.scroll {\r\n    overflow: auto;\r\n    max-height: 250px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
